import { jsx as i } from "react/jsx-runtime";
import g from "clsx";
import { Children as v, useState as N, useMemo as d } from "react";
import t from "./Tag.module.css.js";
import { genColorFromText as f } from "./getColorFromText/index.js";
import { Tooltip as k } from "../Tooltip/Tooltip.js";
const A = ({
  children: o,
  variant: l = "solid",
  color: s,
  size: p = "default",
  fullWidth: x = !1,
  onClick: n,
  className: h
}) => {
  const e = v.toArray(o).join(""), [r, m] = N(null), y = !!r && r.scrollWidth > r.clientWidth, u = g(
    t.tag,
    t[l],
    t[p],
    {
      [t.fullWidth]: x
    },
    h
  ), C = g(u, t.tagButton), b = d(() => s ?? f(e, !1), [s, e]), T = d(() => s ?? f(e, !0), [s, e]), a = `light-dark(${b}, ${T})`, c = {
    "--louis-tag-border-color": a,
    "--louis-tag-background-color": l === "solid" ? a : "transparent",
    "--louis-tag-text-color": l === "outlined" ? a : "var(--lok-color-text-inverse)"
  };
  return /* @__PURE__ */ i(k, { tooltip: o, show: y, children: n ? /* @__PURE__ */ i("button", { type: "button", onClick: n, className: C, style: c, ref: m, children: o }) : /* @__PURE__ */ i("div", { className: u, style: c, ref: m, children: o }) });
};
export {
  A as Tag
};
//# sourceMappingURL=Tag.js.map
